import { renderPage } from "renderPage"
import { ClubForumPostPage } from "./Page"

renderPage({ component: ClubForumPostPage })
